import { Box, CircularProgress, Grid } from "@material-ui/core";
import { useState, useEffect } from "react";
import { Get, Post } from "../../actions";
import { getTranslation } from "../../heplers/translationHelper";
import {
	DEFAULT_PRIMARY_COLOR,
	DEFAULT_SECONDARY_COLOR,
	buildBookingUrl,
	buildIframeCode,
	toColorInput,
} from "../../utils/bookingUrl";

const getColor = (url) =>
	new Promise((resolve) => Get({}, url, null, (res) => resolve(res?.data), () => resolve(null)));

export const CustomIframeDialog = ({ customerId, onColorChange }) => {
	const [primaryColor, setPrimaryColor] = useState(toColorInput(DEFAULT_PRIMARY_COLOR));
	const [secondaryColor, setSecondaryColor] = useState(toColorInput(DEFAULT_SECONDARY_COLOR));

	// the colors saved for the restaurant are the ones used by the booking page
	useEffect(() => {
		Promise.all([getColor("System/GetPrimaryColor"), getColor("System/GetSecondaryColor")]).then(
			([primary, secondary]) => {
				const p = toColorInput(primary, DEFAULT_PRIMARY_COLOR);
				const s = toColorInput(secondary, DEFAULT_SECONDARY_COLOR);
				setPrimaryColor(p);
				setSecondaryColor(s);
				if (onColorChange) onColorChange(p, s);
			}
		);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleUpdate = (colorType, value) => {
		const primary = colorType === "primary" ? value : primaryColor;
		const secondary = colorType === "secondary" ? value : secondaryColor;
		setPrimaryColor(primary);
		setSecondaryColor(secondary);
		if (onColorChange) onColorChange(primary, secondary);
		Post(
			{ key: colorType, color: value.replace("#", "") },
			"/System/ChangeColor",
			null,
			() => {},
			(err) => console.error(`Error saving ${colorType} color:`, err)
		);
	};

	const url = customerId ? buildBookingUrl(customerId, primaryColor, secondaryColor) : null;

	return (
		<Grid container spacing={3}>
			<Grid item sm={12} md={2}>
				<label>{getTranslation("Primary Color:")}</label>
			</Grid>
			<Grid item sm={12} md={10}>
				<input
					type="color"
					value={primaryColor}
					onChange={(e) => handleUpdate("primary", e.target.value)}
				/>
			</Grid>

			<Grid item sm={12} md={2}>
				<label>{getTranslation("Secondary Color:")}</label>
			</Grid>
			<Grid item sm={12} md={10}>
				<input
					type="color"
					value={secondaryColor}
					onChange={(e) => handleUpdate("secondary", e.target.value)}
				/>
			</Grid>

			<Grid item sm={12} md={2}>
				<label>{getTranslation("Generated Code:")}</label>
			</Grid>
			<Grid item sm={12} md={10}>
				<Box border="1px solid gray" p={1} minHeight="100px">
					{url ? (
						<pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>{buildIframeCode(url)}</pre>
					) : (
						<CircularProgress size={24} />
					)}
				</Box>
			</Grid>

			<Grid item sm={12} md={2}>
				<label>{getTranslation("Preview:")}</label>
			</Grid>
			<Grid item sm={12} md={10}>
				<br />
				{url && (
					<iframe
						title={getTranslation("Preview")}
						src={url}
						width="100%"
						height="500px"
						style={{ border: 0 }}
					></iframe>
				)}
			</Grid>
		</Grid>
	);
};
